<template>
    <CardShell>
        <MenuItem
            class="ph3 h3"
            :image="require(`@/assets/img/icon_invoices.svg`)"
            title="Invoices"
            route="/invoices"
            :childRoutes="['/invoice-detail']"
        />
    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import MenuItem from '@/components/global/MenuItem.vue';

export default {
    components: {
        CardShell,
        MenuItem
    }
};
</script>
